export class PayServiceModel {
    public isChecked?: boolean;
    public id?: number;
    public uId?: number;
    public userName?: string;
    public status?: number;
    public statusDetail?: any;
    public amount?: number;
    public amountVND?: number;
    public fee?: number;
    public feeAmount?: number;
    public payment?: number;
    public totalAmount?: number;
    public exchangeRate?: number;
    public guaranteeRate?: number;
    public guaranteeAmount?: number;
    public content?: string;
    public bankAccountNumber?: string;
    public bankAccountName?: string;
    public bankName?: string;
    public createdBy?: string;
    public createdDate?: string;
    public note?: string;
};